export enum WarehouseType {
    None,
    Central,
    Regional,
    District,
    Clinic,
    Department,
    Attendant
}